<!-- Шапка панели данных выбранного титула ЭДО. -->
<template>
  <header class="edo-title-details-header">
    <div class="edo-title-details-header__heading">
      <div class="edo-title-details-header__meta-row">
        <span class="edo-title-details-header__meta">
          {{ label }}<template v-if="role"> · {{ role }}</template>
        </span>
        <BaseBadge
          v-if="statusLabel"
          :label="statusLabel"
          :variant="statusVariant"
        />
      </div>
      <h3 class="edo-title-details-header__title">{{ title }}</h3>
    </div>

    <base-button
      class="edo-title-details-header__close"
      variant="ghost"
      icon="close"
      type="button"
      aria-label="Свернуть данные титула"
      title="Свернуть"
      @click="$emit('close')"
    />

    <div
      v-if="showHelp || actions.length"
      class="edo-title-details-header__controls"
    >
      <div class="edo-title-details-header__actions">
        <base-button
          v-if="showHelp"
          class="edo-title-details-header__help"
          variant="secondary"
          icon="infoCircle"
          type="button"
          @click="$emit('show-help')"
        >
          Что это за титул
        </base-button>
        <base-button
          v-for="action in actions"
          :key="`${action.type}:${action.label}`"
          class="edo-title-details-header__action"
          variant="primary"
          :icon="action.icon || actionIcon(action)"
          type="button"
          @click="$emit('action', action)"
        >
          {{ action.label }}
        </base-button>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: "EdoDocumentTitleDetailsHeader",

  emits: ["action", "close", "show-help"],

  props: {
    label: {
      type: String,
      required: true,
    },
    role: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      required: true,
    },
    statusLabel: {
      type: String,
      default: "",
    },
    statusVariant: {
      type: String,
      default: "default",
      validator: (value) =>
        ["default", "warning", "danger", "info", "success"].includes(value),
    },
    showHelp: {
      type: Boolean,
      default: true,
    },
    actions: {
      type: Array,
      default: () => [],
    },
  },

  methods: {
    actionIcon(action) {
      return action.type === "saby" ? "externalLink" : "edit";
    },
  },
};
</script>

<style scoped>
.edo-title-details-header {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto auto;
  align-items: flex-start;
  gap: 16px;
  padding: 22px 24px 0;
}

.edo-title-details-header__heading {
  display: grid;
  gap: 4px;
  min-width: 0;
}

.edo-title-details-header__meta-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.edo-title-details-header__meta {
  color: #2f4ac0;
  font-size: 13px;
  font-weight: 600;
  line-height: 18px;
}

.edo-title-details-header__title {
  margin: 0;
  color: var(--color-dark);
  font-size: 22px;
  font-weight: 700;
  letter-spacing: -0.01em;
  line-height: 28px;
}

.edo-title-details-header__controls {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  grid-column: 2;
  grid-row: 1;
}

.edo-title-details-header__actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
}

.edo-title-details-header__action,
.edo-title-details-header__help {
  white-space: nowrap;
}

.edo-title-details-header__close {
  grid-column: 3;
  grid-row: 1;
  width: 32px;
  padding: 0;
}

@media (max-width: 720px) {
  .edo-title-details-header {
    position: relative;
    grid-template-columns: minmax(0, 1fr);
    padding: 16px 14px 0;
  }

  .edo-title-details-header__heading {
    padding-right: 44px;
  }

  .edo-title-details-header__title {
    font-size: 19px;
    line-height: 25px;
  }

  .edo-title-details-header__controls {
    display: block;
    grid-column: 1;
    grid-row: 2;
    width: 100%;
  }

  .edo-title-details-header__actions {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 4px;
    width: 100%;
  }

  .edo-title-details-header__action,
  .edo-title-details-header__help {
    width: 100%;
    min-height: 40px;
  }

  .edo-title-details-header__close {
    position: absolute;
    top: 12px;
    right: 10px;
    width: 40px;
    height: 40px;
  }

}

@media (max-width: 420px) {
  .edo-title-details-header__actions {
    grid-template-columns: minmax(0, 1fr);
  }
}
</style>
